import { OptionFilters } from '../../../lib/types/models/options/option'

export const transformOptionFiltersToUrl = (filters?: OptionFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countries && filters.countries.length)
    searchParams.append('countries', filters.countries.join(','))
  if (filters.durationInDays)
    searchParams.append('durationInDays', filters.durationInDays.toString())
  if (filters.formulas && filters.formulas.length)
    searchParams.append('formulas', filters.formulas.join(','))
  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))

  return searchParams.toString()
}

export const transformUrlToOptionFilters = (searchParams: URLSearchParams): OptionFilters => {
  const filters: OptionFilters = {}

  const countries = searchParams.get('countries')
  if (countries) filters.countries = countries.split(',').map((id) => +id)

  const durationInDays = searchParams.get('durationInDays')
  if (durationInDays) filters.durationInDays = +durationInDays

  const formulas = searchParams.get('formulas')
  if (formulas) filters.formulas = formulas.split(',').map((id) => +id)

  const periods = searchParams.get('periods')
  if (periods) filters.periods = periods.split(',').map((id) => +id)

  return filters
}
